import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import axios from 'axios';
import * as React from 'react';
import { Link } from 'react-router-dom';

export default function AddOption({ addressItem, handleAddressDelete }) {
    const deleteFunction = (item) => {
        axios
            .delete(
                "https://admin.sliceguys.co.uk/address-collection/" + item._id
            )
            .then((res) => {
                if (res.data.deletedCount > 0) {
                    handleAddressDelete(item._id)
                    alert("Address Deleted Successfully.");
                }
            });
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <i className="fas fa-ellipsis-v"
                onClick={handleClick}
                aria-controls={open ? 'account-menu' : undefined}
                style={{ cursor: 'pointer', marginLeft: '20px' }}
            ></i>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        // mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <Link to={'/addaddress/' + addressItem._id} style={{ textDecoration: 'none' }}>
                    <MenuItem>
                        Edit
                    </MenuItem>
                </Link>
                <MenuItem onClick={() => deleteFunction(addressItem)}>
                    Delete
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}